// @ts-ignore
import AjaxRequest from './ajax-request';

export default function RequestSharedView(context:any, type:string, endpoint:string, data:any, processSessionResponse:boolean = true, autoError:boolean = true): any {

    //var transport = 'ajax';

    if (endpoint.substring(0,1)==='/') endpoint.substr(1);

    // add utcOffset
    if (!data) data={};
    data.zz = moment().format("ZZ");
    data.sid = gd.sessionId;
    data.cid = gd.companyId;    // cid = CompanyID - it can be empty but usually not

    return AjaxRequest({
        'type'      : type,
        'endpoint'  : endpoint,
        'data'      : data,
        'context'   : context
    }, processSessionResponse, autoError);

};
